/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExposureStatus } from './ExposureStatus';
import {
    ExposureStatusFromJSON,
    ExposureStatusFromJSONTyped,
    ExposureStatusToJSON,
} from './ExposureStatus';
import type { ExposureTypes } from './ExposureTypes';
import {
    ExposureTypesFromJSON,
    ExposureTypesFromJSONTyped,
    ExposureTypesToJSON,
} from './ExposureTypes';

/**
 * 
 * @export
 * @interface SecuredAllocation
 */
export interface SecuredAllocation {
    /**
     * 
     * @type {ExposureTypes}
     * @memberof SecuredAllocation
     */
    exposureType: ExposureTypes;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    currentExposure: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    targetExposure: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    activeExposure: number;
    /**
     * 
     * @type {ExposureStatus}
     * @memberof SecuredAllocation
     */
    exposureStatus: ExposureStatus;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    maxBuyConstraint?: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    targetSecuredness: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    previousTargetSecuredness: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    initialSecuredness: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    targetDuration: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    initialDuration: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    targetFundedness: number;
    /**
     * 
     * @type {number}
     * @memberof SecuredAllocation
     */
    initialFundedness: number;
}



/**
 * Check if a given object implements the SecuredAllocation interface.
 */
export function instanceOfSecuredAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "exposureType" in value;
    isInstance = isInstance && "currentExposure" in value;
    isInstance = isInstance && "targetExposure" in value;
    isInstance = isInstance && "activeExposure" in value;
    isInstance = isInstance && "exposureStatus" in value;
    isInstance = isInstance && "targetSecuredness" in value;
    isInstance = isInstance && "previousTargetSecuredness" in value;
    isInstance = isInstance && "initialSecuredness" in value;
    isInstance = isInstance && "targetDuration" in value;
    isInstance = isInstance && "initialDuration" in value;
    isInstance = isInstance && "targetFundedness" in value;
    isInstance = isInstance && "initialFundedness" in value;

    return isInstance;
}

export function SecuredAllocationFromJSON(json: any): SecuredAllocation {
    return SecuredAllocationFromJSONTyped(json, false);
}

export function SecuredAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecuredAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exposureType': ExposureTypesFromJSON(json['exposure_type']),
        'currentExposure': json['current_exposure'],
        'targetExposure': json['target_exposure'],
        'activeExposure': json['active_exposure'],
        'exposureStatus': ExposureStatusFromJSON(json['exposure_status']),
        'maxBuyConstraint': !exists(json, 'max_buy_constraint') ? undefined : json['max_buy_constraint'],
        'targetSecuredness': json['target_securedness'],
        'previousTargetSecuredness': json['previous_target_securedness'],
        'initialSecuredness': json['initial_securedness'],
        'targetDuration': json['target_duration'],
        'initialDuration': json['initial_duration'],
        'targetFundedness': json['target_fundedness'],
        'initialFundedness': json['initial_fundedness'],
    };
}

export function SecuredAllocationToJSON(value?: SecuredAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exposure_type': ExposureTypesToJSON(value.exposureType),
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
        'exposure_status': ExposureStatusToJSON(value.exposureStatus),
        'max_buy_constraint': value.maxBuyConstraint,
        'target_securedness': value.targetSecuredness,
        'previous_target_securedness': value.previousTargetSecuredness,
        'initial_securedness': value.initialSecuredness,
        'target_duration': value.targetDuration,
        'initial_duration': value.initialDuration,
        'target_fundedness': value.targetFundedness,
        'initial_fundedness': value.initialFundedness,
    };
}

